import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import TourPageCategoryTile from 'components/Tours/TourPageCategoryTile'
import qs from 'qs'
import Places from 'constants/places'

interface Props {
  category: App.Tours.CategoryData
}

function TourPageSearchTourCategoryTile(props: Props) {
  const { category } = props
  const intl = useIntl()

  const categorySearchUrl = useMemo(() => {
    const { parameterName, parameterValue } = category

    if (parameterName === 'link') {
      return parameterValue
    }
    const query: Record<string, any> = {
      destinationId: Places.Anywhere.id,
      destinationName: Places.Anywhere.name,
    }

    if (parameterName && parameterValue) {
      query[parameterName] = parameterValue
    }

    const queryString = qs.stringify(query, {
      arrayFormat: 'comma',
    })

    return `/search/tours?${queryString}`
  }, [category])

  return <TourPageCategoryTile
    toUrl={categorySearchUrl}
    category={category}
    actionText={intl.formatMessage(
      {
        id: 'cgyG0UvuOEaOWHs3T36Q',
        defaultMessage: 'View offers',
        description: 'Action button text on a tour category tile to view available offers',
      },
    )}
  />
}

export default TourPageSearchTourCategoryTile
